import React, { useState } from 'react'

// Console logs
import "../utils/dropConsole";

// Internationalization
import '../i18n/config'

// Routing
import { BrowserRouter } from "react-router-dom";
import { RouterConfig } from "../navigation/RouterConfig";

// Themify with react styled-components
import { ThemeProvider } from 'styled-components'
import { lightTheme, darkTheme } from '../styles/theme'
import { GlobalStyles } from '../styles/global'

import { Header, Footer} from '../containers'

import "./App.css";

function App() {

  // Theme toggle
  const [theme, setTheme] = useState('light');
  const toggleTheme = () => {
    if (theme === 'light') setTheme('dark');
    else setTheme('light');
    console.log("theme=", theme ? "dark" : "light");
  }

  return (
    <ThemeProvider 
      theme={ theme === 'light'? 
      lightTheme : darkTheme } 
      value={theme}
    >
      <GlobalStyles />
      <BrowserRouter>   
        <Header toggle={toggleTheme} />
        <RouterConfig />
        <Footer />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;